export default __webpack_public_path__ + "static/media/HappyBirthday_08.2dc9aa3f.png";